import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  CardMedia,
} from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const categories = [
  {
    name: "Classroom Furniture",
    image:
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=1000&q=80",
    description: "Desks, chairs, whiteboards and classroom essentials",
  },
  {
    name: "Administration Supplies",
    image:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1000&q=80",
    description: "Office furniture, printers and administration tools",
  },
  {
    name: "IT Equipment",
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1000&q=80",
    description: "Laptops, desktops, projectors and networking devices",
  },
  {
    name: "Library Resources",
    image:
      "https://images.unsplash.com/photo-1507842217343-583bb7270b66?auto=format&fit=crop&w=1000&q=80",
    description: "Bookshelves, study desks and digital library tools",
  },
  {
    name: "Laboratory Equipment",
    image:
      "https://images.unsplash.com/photo-1532187643603-ba119ca4109e?auto=format&fit=crop&w=1000&q=80",
    description: "Microscopes, lab tools and scientific instruments",
  },
  {
    name: "Sports Gear",
    image:
      "https://images.unsplash.com/photo-1517649763962-0c623066013b?auto=format&fit=crop&w=1000&q=80",
    description: "Indoor and outdoor sports equipment",
  },
  {
    name: "Safety Equipment",
    image:
      "https://images.unsplash.com/photo-1581092921461-eab62e97a780?auto=format&fit=crop&w=1000&q=80",
    description: "Fire safety, first aid and protective equipment",
  },
];

const Categories = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        px: { xs: 2, md: 6 },
        py: 8,
        background: "#f7f9fc",
      }}
    >
      <Box textAlign="center" mb={6}>
        <Typography
          variant="h3"
          fontWeight="bold"
          sx={{ color: "#1f2937", mb: 2 }}
        >
          Explore Categories
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#6b7280",
            maxWidth: "700px",
            mx: "auto",
            fontSize: "1.05rem",
          }}
        >
          Find premium products for schools, colleges, offices and institutions.
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {categories.map((cat, index) => (
          <Grid item xs={12} sm={6} lg={3} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: index * 0.1,
              }}
              viewport={{ once: true }}
              whileHover={{ y: -12 }}
            >
              <Card
                onClick={() => navigate(`/category/${cat.name}`)}
                sx={{
                  borderRadius: "24px",
                  overflow: "hidden",
                  cursor: "pointer",
                  position: "relative",
                  height: 370,
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  transition: "all 0.4s ease",
                  "&:hover": {
                    boxShadow: "0 18px 45px rgba(0,0,0,0.16)",
                  },
                  "&:hover .category-image": {
                    transform: "scale(1.12)",
                  },
                  "&:hover .category-overlay": {
                    background:
                      "linear-gradient(to top, rgba(0,0,0,0.85), rgba(0,0,0,0.25))",
                  },
                  "&:hover .category-arrow": {
                    transform: "translateX(6px)",
                    opacity: 1,
                  },
                }}
              >
                <Box sx={{ position: "relative", height: "100%" }}>
                  <CardMedia
                    component="img"
                    image={cat.image}
                    alt={cat.name}
                    className="category-image"
                    sx={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                      transition: "transform 0.7s ease",
                    }}
                  />

                  <Box
                    className="category-overlay"
                    sx={{
                      position: "absolute",
                      inset: 0,
                      background:
                        "linear-gradient(to top, rgba(0,0,0,0.75), rgba(0,0,0,0.15))",
                      transition: "all 0.4s ease",
                    }}
                  />

                  <CardContent
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      color: "#fff",
                      zIndex: 2,
                      p: 3,
                    }}
                  >
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      sx={{ mb: 1 }}
                    >
                      {cat.name}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        color: "rgba(255,255,255,0.85)",
                        lineHeight: 1.6,
                        mb: 2,
                      }}
                    >
                      {cat.description}
                    </Typography>

                    <Box
                      className="category-arrow"
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 1,
                        fontWeight: 600,
                        fontSize: "0.95rem",
                        opacity: 0.85,
                        transition: "all 0.3s ease",
                      }}
                    >
                      Explore Category →
                    </Box>
                  </CardContent>
                </Box>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Categories;